export default "__VITE_ASSET__DaLgH$OR__"